<template>
    <div class="my-expense-table">
        <div class="content">
            <div class="wrap">
                <div class="wrap__tree">
                    <div class="nav-tree">
                        <div class="nav-tree">
                            <el-radio @change="stateChange" v-model="activeState" size="mini" label="businessUnitTasksExpenses" border>{{$t('users_tab_hris_expenses_bu')}}</el-radio>
                            <el-radio @change="stateChange" v-model="activeState" size="mini" label="engagementTaskExpenses" border>{{$t('users_tab_hris_expenses_e')}}</el-radio>
                            <el-radio @change="stateChange" v-model="activeState" size="mini" label="projectTaskExpenses" border>{{$t('users_tab_hris_expenses_p')}}</el-radio>
                            <el-select class="inputs" no-data-text="no data" v-model="projectId" :placeholder="placeholder" size="mini">
                                <el-option
                                        v-for="item in projects"
                                        :key="item.id"
                                        :label="item.name"
                                        :value="item.id"
                                        @click.native="setValueProjectAfterSubmit(item.id, activeState)">
                                </el-option>
                            </el-select>
                        </div>
                        <div class="nav-tree">
                            <el-button v-if="activeTab === 'requestTaskExpense'" @click="openModalRequest(activeState)" class="nav-tree__item_btn" size="mini" type="primary" plain icon="el-icon-plus">{{$t('users_tab_hris_expenses_requestExpense')}}</el-button>
                            <el-button v-if="activeTab === 'taskExpense'"  @click="openModal(activeState)" class="nav-tree__item_btn" size="mini" type="primary" plain icon="el-icon-plus">{{$t('users_tab_hris_expenses_addExpense')}}</el-button>
                        </div>
                    </div>
                    <el-tabs v-model="activeTab" type="card" @tab-click="handleClickMainTabs">
                        <el-tab-pane name="requestTaskExpense" :label="$t('users_tab_hris_expenses_requestExpenses')">
                        </el-tab-pane>
                        <el-tab-pane name="taskExpense" :label="$t('users_tab_hris_expenses_addedExpenses')">
                        </el-tab-pane>
                    </el-tabs>
                    <el-table
                            :data="myExpenseList"
                            style="width: 100%"
                            :empty-text="$t('general_noData')"
                            :cell-class-name="cellClassName"
                            :row-class-name="tableRowClassName"
                            :header-cell-class-name="headerCellClassName"
                            @cell-click="cellClick">
                        <el-table-column
                                type="index"
                                width="50">
                        </el-table-column>
                        <el-table-column
                                prop="code"
                                :label="$t('users_tab_hris_expenses_no')"
                                width="100">
                        </el-table-column>
                        <el-table-column
                                prop="expenseDate"
                                :label="$t('users_tab_hris_expenses_date')"
                                width="110">
                        </el-table-column>
                        <el-table-column
                                prop="projectTaskExpenseInventoryItemId.name"
                                :label="$t('users_tab_hris_expenses_expenseItem')"
                                width="100">
                        </el-table-column>
                        <el-table-column
                                :label="$t('users_tab_hris_expenses_type')"
                                width="130">
                            <template slot-scope="scope">
                                <el-tag v-if="scope.row.reimbursable"
                                        size="mini"
                                        type="primary"
                                        plain>
                                    {{$t('users_tab_hris_expenses_reimbursable')}}
                                </el-tag>
                                <div style="margin-top:5px;"></div>
                                <el-tag v-if="scope.row.isBillable"
                                        size="mini"
                                        type="primary"
                                        plain>
                                    {{$t('users_tab_hris_expenses_billable')}}
                                </el-tag>
                            </template>
                        </el-table-column>
                        <el-table-column
                                prop="companyVendor.name"
                                :label="$t('users_tab_hris_expenses_vendor')"
                                width="120">
                        </el-table-column>
                        <el-table-column
                                prop="status"
                                :label="$t('users_tab_hris_expenses_status')"
                                width="90">
                            <template slot-scope="scope">
                                <el-button v-if="scope.row.status === 'Pending'"
                                           size="mini"
                                           type="info"
                                           plain
                                           v-html="scope.row.status">
                                </el-button>
                                <el-button v-if="scope.row.status === 'Submited'"
                                           size="mini"
                                           type="primary"
                                           plain
                                           v-html="activeTab === 'taskExpense' ? 'Submited' : 'Requested' ">
                                </el-button>
                                <el-button v-if="scope.row.status === 'Approved'"
                                           size="mini"
                                           type="success"
                                           plain
                                           v-html="scope.row.status">
                                </el-button>
                                <el-button v-if="scope.row.status === 'Rejected'"
                                           size="mini"
                                           type="danger"
                                           plain
                                           v-html="scope.row.status">
                                </el-button>
                            </template>
                        </el-table-column>
                        <el-table-column
                                prop="companyClient.name"
                                :label="$t('users_tab_hris_expenses_client')"
                                width="120">
                        </el-table-column>
                        <el-table-column
                                :label="$t('users_tab_hris_expenses_project')"
                                width="180">
                            <template slot-scope="scope">
                                <div v-if="scope.row.project">
                                    {{scope.row.project.name}}
                                </div>
                                <div v-if="scope.row.engagement">
                                    {{scope.row.engagement.name}}
                                </div>
                                <div v-if="scope.row.businessUnit">
                                    {{scope.row.businessUnit.name}}
                                </div>
                            </template>
                        </el-table-column>
                        <el-table-column
                                prop="companyUser.user.fullName"
                                :label="$t('users_tab_hris_expenses_from')"
                                width="150">
                        </el-table-column>
                        <el-table-column
                                prop="totalAmount"
                                :label="$t('users_tab_hris_expenses_totalAmount')"
                                width="100">
                            <template slot-scope="scope">
                                {{formatPrice(scope.row.totalAmount)}}
                            </template>
                        </el-table-column>
                        <el-table-column
                                :label="$t('users_tab_hris_expenses_file')"
                                width="50">
                            <template slot-scope="scope">
                                <el-button v-if="scope.row.fileId !== null"
                                           size="mini"
                                           type="primary"
                                           circle
                                           icon="el-icon-link"
                                           @click="handleShowImg(scope.$index, scope.row, activeState, activeTab)"></el-button>
                            </template>
                        </el-table-column>
                        <el-table-column
                                :label="$t('users_tab_hris_expenses_operations')"
                                width="250">
                            <template slot-scope="scope">
                                <div v-if="companyLayout.companyUserId === scope.row.companyUserId">
                                <el-button
                                        v-if="scope.row.status === 'Pending'"
                                        size="mini"
                                        type="primary"
                                        plain
                                        @click="handleSubmit(scope.$index, scope.row, activeState, activeTab)" v-html="activeTab === 'taskExpense' ? 'Submit' : 'Request' ">Submit</el-button>
                                <el-button
                                        v-if="scope.row.status === 'Pending' || scope.row.status === 'Rejected'"
                                        size="mini"
                                        type="primary"
                                        plain
                                        icon="el-icon-edit"
                                        @click="handleEdit(scope.$index, scope.row, activeState, activeTab)"></el-button>
                                <el-button
                                        size="mini"
                                        type="danger"
                                        plain
                                        icon="el-icon-delete"
                                        @click="handleDelete(scope.$index, scope.row, activeState, activeTab)"></el-button>
                                </div>
                            </template>
                        </el-table-column>
                    </el-table>
                </div>
            </div>
        </div>


        <projectExpenseRequestModal
                @setValueProject='setValueProjectAfterSubmitModal'
                :selectedRow="selectedRow"
                ref="projectExpenseRequest"/>

        <projectExpenseModal
                @refreshUserPage='setValueProjectAfterSubmitModal'
                :selectedRow="selectedRow"
                ref="projectExpenseModal"/>

        <expenseInfoModal
                ref="expenseInfoModal"
                @refreshUserPage="setValueProjectAfterSubmitModal"/>


        <div v-if="viewerType == 1">
            <sweet-modal blocking v-if="viewerType == 1" ref="nestedChild">
                <iframe class="iframe" :src="fileUrl" frameborder="0"></iframe>
            </sweet-modal>
        </div>
        <div v-if="viewerType == 2">
            <div v-show="false" class="images" v-viewer="{movable: true}">
                <img :src="fileUrl" :key="fileUrl" />
            </div>
        </div>
        <div class="mod" v-if="viewerType == 3">
            <div @click="closeMod" class="mod__close">
                <span>x</span>
            </div>
            <Media
                    :kind="'video'"
                    :controls="true"
                    :src="fileUrl"
            >
            </Media>
        </div>
        <div class="mod" v-if="viewerType == 4">
            <div @click="closeMod" class="mod__close">
                <span>x</span>
            </div>
            <Media
                    :kind="'audio'"
                    :controls="true"
                    :src="fileUrl"
            >
            </Media>
        </div>
    </div>
</template>

<script>
  import Media from '@dongido/vue-viaudio'
  import { SweetModal } from '@totalflow4/tfsweet-modal-vue';
  import projectExpenseModal from '@/components/Projects/projectExpenseModal.vue'
  import expenseInfoModal from '@/components/expenses/expenseInfoModal.vue'
  import projectExpenseRequestModal from '@/components/Projects/projectExpenseRequestModal.vue'


  let moment = require('moment')
  import axios from 'axios'
  export default {
    name: 'myExpenseTable',
    components: {
      SweetModal,

      projectExpenseModal,
      expenseInfoModal,
      projectExpenseRequestModal,
      Media
    },
    computed: {
      companyLayout() {
        return this.$store.getters.getCompanyLayout
      },
    },
    mounted() {

    },
    data(){
      return {
        activeTab: 'taskExpense',
        activeState:'projectTaskExpenses',
        projectId: '',
        projects: [],
        myExpenseList: [],
        placeholder: 'Select Project',
        moment:moment,
        viewerType: 0,
        fileUrl: '',
        type: '',
        selectedRow:{},
        // selectedRowId:'',
      }
    },
    methods: {
      openModal(state){
        this.$refs['projectExpenseModal'].openModalFromExpense(state)
      },
      openModalRequest(state) {
        const urlParts = this.buildUrl(state, 'requestTaskExpense')
        console.log('urlParts.myState', urlParts.myState)
        this.$refs['projectExpenseRequest'].openModalFromExpense(urlParts.myState)
      },
      stateChange(state){
        this.getProjects(state)
      },
      openTable(){
        this.getProjects(this.activeState)
      },
      getProjects(state){
        let myState = ''
        switch (state){
          case 'projectTaskExpenses':
            this.projects = [{name: this.$i18n.t('users_tab_hris_expenses_p_all'), id: 'all'}]
            myState = 'projects'
            break;
          case 'engagementTaskExpenses':
            this.projects = [{name: this.$i18n.t('users_tab_hris_expenses_e_all'), id: 'all'}]
            myState = 'engagements'
            break;
          case 'businessUnitTasksExpenses':
            this.projects = [{name: this.$i18n.t('users_tab_hris_expenses_bu_all'), id: 'all'}]
            myState = 'businessUnits'
            break;
        }
        axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
        axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
        axios
          .post(`/api/v1/${myState}/list?companyId=${this.$route.query.companyId}`)
          .then(response => {
            this.projects =  this.projects.concat(response.data.list)
            this.projectId = this.projects[0].id
            this.setValueProjectAfterSubmit(this.projectId, this.activeState)
          }).catch(error =>{

        })
      },
      cellClick(row, column, event){
        if(column.label !== 'File' && column.label !== 'Operations') {
          this.openExpenseModal(row.companyId, row.projectId || row.engagementId || row.businessUnitId, row.projectTaskId|| row.engagementTaskId || row.businessUnitTaskId, row.id, this.activeState)
        }
      },
      handleClickMainTabs(tab, event){
        if(this.projectId === 'all'){
          this.setMyValueProjectAll(this.activeState, tab.name)
        }else{
          this.setMyValueProject(this.projectId, this.activeState, tab.name)
        }
      },
      openExpenseModal(companyId, projectId, projectTaskId, projectTaskExpenseId, state){
        this.$refs.expenseInfoModal.openModalInfo(companyId, projectId, projectTaskId, projectTaskExpenseId, state);
      },
      setValueProjectAfterSubmitModal(projectId){
        if(this.projectId === 'all'){
          this.setMyValueProjectAll(this.activeState, this.activeTab)
        }else{
          this.setMyValueProject(projectId, this.activeState, this.activeTab)
        }
      },
      setValueProjectAfterSubmit(projectId, state){
        if(projectId === 'all'){
          this.setMyValueProjectAll(state, this.activeTab)
        }else{
          this.setMyValueProject(projectId, state, this.activeTab)
        }
      },
      setMyValueProject(projectId, state, activeTab){
        this.projectId = projectId

        const urlParts = this.buildUrl(state, activeTab, false)

        let loader = this.$loading.show();
        axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
        axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
        axios
          .post(`/api/v1/${urlParts.myState}/myList?companyId=${this.$route.query.companyId}&${urlParts.stateProjectId}=${projectId}`)
          .then(response => {
            this.myExpenseList = response.data.list
            loader.hide()
          }).catch(error =>{
          loader.hide()
        })
      },
      setMyValueProjectAll(state, activeTab){
        const urlParts = this.buildUrl(state, activeTab, false)
        console.log('urlPartsurlPartsurlParts', urlParts)
        let loader = this.$loading.show();
        axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
        axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
        axios
          .post(`/api/v1/${urlParts.myState}/myList?companyId=${this.$route.query.companyId}`)
          .then(response => {
            this.myExpenseList = response.data.list
            loader.hide()
          }).catch(error =>{
          loader.hide()
        })
      },
      checkType(url) {
        let type = url.split('.').pop().toUpperCase()
        if (type == 'STEP' || type == 'STP' || type == 'IGES' || type == 'IGS' || type == 'BREP' || type == 'STL' || type == 'SAT' || type == 'X_T' || type == 'X_B' || type == 'SLDPRT' || type == 'DWG' || type == 'DXF' || type == 'DWF' || type == 'HPGL' || type == 'PLT' || type == 'CGM' || type == 'SVG' || type == 'EMF' || type == 'WMF' || type == 'JPG' || type == 'JPEG' || type == 'PNG' || type == 'BMP' || type == 'OGG' || type == 'MP4' || type == 'WMA' || type == 'MP3' || type == 'WAV' || type == 'OGG' || type == 'M4A' || type == 'PDF') {
          return true
        } else {
          return false
        }
      },
      handleSubmit(index, row, state, activeTab) {

        const urlParts = this.buildUrl(state, activeTab, row)

        if(row.projectTaskId === null){
          row.projectTaskId = 0
        }

        //TODO add BU ENG

        axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
        axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
        axios
          .post(`/api/v1/${urlParts.myState}/submit?companyId=${this.$route.query.companyId}&${urlParts.stateProjectId}=${urlParts.projectId}&${urlParts.stateTaskId}=${urlParts.taskId}&${urlParts.stateExpenseId}=${row.id}`)
          .then(response => {
            this.notification("Success", "Submit Expense", "success")
            this.setValueProjectAfterSubmit(this.projectId, this.activeState)
          })
          .catch(error => {
            console.log('An error occurred:', error);
          });
        console.log(index, row)
      },
      handleEdit(index, row, state, activeTab) {
        const urlParts = this.buildUrl(state, activeTab, row)
        if(activeTab === 'requestTaskExpense'){
          this.$refs['projectExpenseRequest'].openModalFromExpenseEdit(row, urlParts.myState)
        }else if(activeTab === 'taskExpense'){
          this.$refs['projectExpenseModal'].openModalFromExpenseEdit(row, urlParts.myState)
        }
      },
      handleShowImg(index, row, state, activeTab){

        const urlParts = this.buildUrl(state, activeTab, row)

        if(row.projectTaskId === null){
          row.projectTaskId = 0
        }

        //TODO add BU ENG

        axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
        axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
        axios
          .post(`/api/v1/${urlParts.myState}/fieldInfo?companyId=${this.$route.query.companyId}&${urlParts.stateProjectId}=${urlParts.projectId}&${urlParts.stateTaskId}=${urlParts.taskId}&${urlParts.stateExpenseId}=${row.id}&field=file`)
          .then(response => {
            this.viewFile(response.data.fieldInfo.url)
          })
          .catch(error => {
            // this.$refs.confirmation.close()
            console.log('An error occurred:', error);
          });
      },
      viewFile(url) {
        let type = url.split('.').pop().toUpperCase()
        if (type == 'STEP' || type == 'STP' || type == 'IGES' || type == 'IGS' || type == 'BREP' || type == 'STL' || type == 'SAT' || type == 'X_T' || type == 'X_B' || type == 'SLDPRT' || type == 'DWG' || type == 'DXF' || type == 'DWF' || type == 'HPGL' || type == 'PLT' || type == 'CGM' || type == 'SVG' || type == 'EMF' || type == 'WMF' || type == 'JPG' || type == 'JPEG' || type == 'PNG' || type == 'BMP' || type == 'OGG' || type == 'MP4' || type == 'WMA' || type == 'MP3' || type == 'WAV' || type == 'OGG' || type == 'M4A' || type == 'PDF') {
          this.fileUrl = url
          this.type = this.fileUrl.split('.').pop().toUpperCase()
          console.log('---', this.fileUrl, this.type);

          if (this.type == 'JPG' || this.type == 'JPEG' || this.type == 'PNG' || this.type == 'BMP') {
            this.viewerType = 2;
            setTimeout(() => {
              console.log('-----', this.$el);
              const viewer = this.$el.querySelector('.images').$viewer
              viewer.show()
            }, 300);
          } else if (this.type == 'OGG' || this.type == 'MP4') {
            this.viewerType = 3;
            setTimeout(() => {
              // this.$refs.video.open();
            }, 300);
          } else if (this.type == 'WMA' || this.type == 'MP3' || this.type == 'WAV' || this.type == 'OGG' || this.type == 'M4A') {
            this.viewerType = 4;
            setTimeout(() => {
              // this.$refs.video.open();
            }, 300);
          } else if (this.type == 'PDF') {
            this.viewerType = 1;
            this.fileUrl = process.env.VUE_APP_TF_PDF_VIEWER_BASE_URL + '/?file=' + this.fileUrl
            setTimeout(() => {
              // this.$refs.nestedChild.open();
              window.open(this.fileUrl);
            }, 300);
          } else if (this.type == 'STEP' || this.type == 'STP' || this.type == 'IGES' || this.type == 'IGS' || this.type == 'BREP' || this.type == 'STL' || this.type == 'SAT' || this.type == 'X_T' || this.type == 'X_B' || this.type == 'SLDPRT' || this.type == 'DWG' || this.type == 'DXF' || this.type == 'DWF' || this.type == 'HPGL' || this.type == 'PLT' || this.type == 'CGM' || this.type == 'SVG' || this.type == 'EMF' || this.type == 'WMF') {
            // this.viewerType = 1;
            this.fileUrl = 'https://sharecad.org/cadframe/load?url=' + this.fileUrl
            setTimeout(() => {
              // this.$refs.nestedChild.open();
              window.open(this.fileUrl);
            }, 300);
          }
        }
      },
      cellClassName({row, column, rowIndex, columnIndex}){
        // console.log("COLUMN", columnIndex)
        // if(columnIndex === 0 || columnIndex === 5){
        //   return 'align-center'
        // }
      },
      tableRowClassName({row, rowIndex}) {
        return 'table-rows'
      },
      headerCellClassName({row, column, rowIndex, columnIndex}){
        // if(columnIndex === 0 || columnIndex === 5){
        //   return 'align-center'
        // }
      },
      formatPrice(value) {
        let val = (value/1).toFixed(2).replace('.', ',')
        return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".")
      },
      notification(title, message, type) {
        this.$notify({
          title: title,
          message: message,
          type: type
        });
      },
      handleDelete(index, row, state, activeTab){


        const urlParts = this.buildUrl(state, activeTab, row)
        console.log('urlParts', urlParts)

        this.$confirm('This will permanently delete the Expense. Continue?', 'Warning', {
          confirmButtonText: 'OK',
          cancelButtonText: 'Cancel',
          type: 'info'
        }).then(() => {
          this.$message({
            type: 'success',
            message: 'Delete completed'
          });

          let loader = this.$loading.show();
          axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
          axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
          axios
            .post(`/api/v1/${urlParts.myState}/delete?companyId=${this.$route.query.companyId}&${urlParts.stateProjectId}=${urlParts.projectId}&${urlParts.stateTaskId}=${urlParts.taskId}&${urlParts.stateExpenseId}=${row.id}`)
            .then(response => {
              this.setValueProjectAfterSubmit(this.projectId, state)
              loader.hide()
            })
            .catch(error => {
              console.log('An error occurred:', error);
              loader.hide()
            });
        }).catch(() => {
          this.$message({
            type: 'info',
            message: 'Delete canceled'
          });
        });
      },
      buildUrl(state, activeTab, row) {
        console.log('state, activeTab, row', state, activeTab, row)
        let myState = ''
        let stateProjectId = ''
        let stateTaskId = ''
        let projectId = ''
        let taskId = ''
        let stateExpenseId = ''
        switch (activeTab) {
          case 'taskExpense':
            if (state === 'projectTaskExpenses') {
              myState = 'projectTaskExpenses'
              stateProjectId = 'projectId'
              stateTaskId = 'projectTaskId'
              if(row){
                projectId = row.project.id
                taskId = row.projectTaskId
              }
              stateExpenseId = 'projectTaskExpenseId'
            } else if (state === 'engagementTaskExpenses') {
              myState = 'engagementTaskExpenses'
              stateProjectId = 'engagementId'
              stateTaskId = 'engagementTaskId'
              if(row){
                projectId = row.engagement.id
                taskId = row.engagementTaskId
              }
              stateExpenseId = 'engagementTaskExpenseId'
            } else if (state === 'businessUnitTaskExpenses') {
              myState = 'businessUnitTaskExpenses'
              stateProjectId = 'businessUnitId'
              stateTaskId = 'businessUnitTaskId'
              if(row){
                projectId = row.businessUnit.id
                taskId = row.businessUnitTaskId
              }
              stateExpenseId = 'businessUnitTaskExpenseId'
            }
            break;
          case 'requestTaskExpense':
            if (state === 'projectTaskExpenses') {
              myState = 'requestProjectTaskExpenses'
              stateProjectId = 'projectId'
              stateTaskId = 'projectTaskId'
              if(row){
                projectId = row.project.id
                taskId = row.projectTaskId
              }
              stateExpenseId = 'projectTaskExpenseId'
            } else if (state === 'engagementTaskExpenses') {
              myState = 'requestEngagementTaskExpenses'
              stateProjectId = 'engagementId'
              stateTaskId = 'engagementTaskId'
              if(row){
                projectId = row.engagement.id
                taskId = row.engagementTaskId
              }
              stateExpenseId = 'engagementTaskExpenseId'
            } else if (state === 'businessUnitTaskExpenses') {
              myState = 'requestBusinessUnitTaskExpenses'
              stateProjectId = 'businessUnitId'
              stateTaskId = 'businessUnitTaskId'
              if(row){
                projectId = row.businessUnit.id
                taskId = row.businessUnitTaskId
              }
              stateExpenseId = 'businessUnitTaskExpenseId'
            }
            break;
        }
        return {
          myState: myState,
          stateProjectId: stateProjectId,
          stateTaskId: stateTaskId,
          projectId: projectId,
          taskId: taskId,
          stateExpenseId: stateExpenseId
        }
      }
    },
    watch:{
      myExpenseList(val){
        val.forEach(i =>{
          i.expenseDate = moment(i.createDate.toString(), 'X').format('DD MMM YYYY')
          if(i.reimbursable === 1){
            i.reimbursable = 'Reimbursable'
          }else if(i.reimbursable === 0){
            i.reimbursable = false
          }
          if(i.isBillable === 1){
            i.isBillable = 'Billable'
          }else if(i.isBillable === 0){
            i.isBillable = false
          }
          if(i.status === 1){
            i.status = 'Pending'
          }else if(i.status === 2){
            i.status = 'Submited'
          }else if(i.status === 3){
            i.status = 'Approved'
          }else if(i.status === 4){
            i.status = 'Rejected'
          }
        })
      }
    }
  }
</script>

<style lang="less" scoped>
    // [ Nav tree ] start
    .nav-tree {
        padding-bottom: 10px;
        &__item {
            margin: 0 0 5px 0;
            &_btn{
                /*margin-left:10px;*/
            }
        }
        .el-button {
            margin-right: 10px;
        }
        .el-radio{
            margin-right:0;
        }
        .inputs{
            margin-left:10px;
        }
    }
</style>
